import cn from 'classnames'
import { DropdownOptionModel } from 'ext-ui/components/Dropdown/components/DropdownOption/DropdownOption'
import { DropdownHandleProps } from 'ext-ui/components/Dropdown/hooks/useDropdownLogic'
import { TextInputProps } from 'ext-ui/components/TextInput/TextInput'
import { LoadingState } from 'ext-ui/hooks/useLoadingStateAnimation'
import React, { forwardRef } from 'react'
import { CreditCardDropdownOptionDetails } from 'src/components/CreditCardDropdownV2/CreditCardDropdownOption'
import SvgCardNew from 'src/components/Svgs/SvgCardNew'
import SvgChevronUp from 'src/components/Svgs/SvgChevronUp'
import { useTranslate } from 'src/localization/Trns'

import styles from './CreditCardDropdownHandle.style'

export type CreditCardDropdownHandleProps = DropdownHandleProps &
  Omit<TextInputProps, 'iconRight'> & {
    open: boolean
    selectedValues?: DropdownOptionModel<CreditCardDropdownOptionDetails>[]
    loadingState?: LoadingState
    searchable?: boolean
  }

const CreditCardDropdownHandle = forwardRef<
  HTMLDivElement,
  CreditCardDropdownHandleProps
>((props, ref) => {
  const { open, className, onClick, onKeyDown } = props

  const translate = useTranslate()

  return (
    <div
      ref={ref}
      className={cn('CreditCardDropdownHandle', className)}
      css={styles}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="CreditCardDropdownHandle container">
        <div className="CreditCardDropdownHandle content">
          {props.selectedValues !== undefined &&
            props.selectedValues.length === 1 && (
              <>
                <div className="CreditCardDropdownHandle cardStack">
                  <img
                    src={props.selectedValues.at(0)?.details?.imageUrl}
                    className={cn('CreditCardDropdownHandle cardIcon', {
                      source: !props.selectedValues.at(0)?.details?.isBudget,
                    })}
                    alt={''}
                  />
                </div>
                <span className="CreditCardDropdownHandle value">
                  {props.selectedValues.at(0)?.label}
                </span>
              </>
            )}
          {props.selectedValues !== undefined &&
            props.selectedValues.length > 1 && (
              <>
                <div className="CreditCardDropdownHandle cardStack">
                  <img
                    src={props.selectedValues.at(1)?.details?.imageUrl}
                    className={cn('CreditCardDropdownHandle cardIcon', {
                      source: !props.selectedValues.at(1)?.details?.isBudget,
                    })}
                    alt=""
                  />
                  <img
                    src={props.selectedValues.at(0)?.details?.imageUrl}
                    className={cn('CreditCardDropdownHandle cardIcon offset', {
                      source: !props.selectedValues.at(0)?.details?.isBudget,
                    })}
                    alt=""
                  />
                </div>
                <span className="CreditCardDropdownHandle value">
                  {translate('Multiple Card Accounts')}
                </span>
              </>
            )}
          {(props.selectedValues === undefined ||
            props.selectedValues.length === 0) && (
            <>
              <span className="CreditCardDropdownHandle genericCardIcon">
                <SvgCardNew />
              </span>
              <span className="CreditCardDropdownHandle value">
                {translate('All Card Accounts')}
              </span>
            </>
          )}
        </div>
        <SvgChevronUp width={16} height={16} className={cn('icon', { open })} />
      </div>
    </div>
  )
})

export default CreditCardDropdownHandle
